define('app/leaflet-extensions/leaflet-print',['leaflet'], function() {
  'use strict';

  // @ts-ignore
  L.Control.Print = L.Control.extend({
    // @ts-ignore
    onAdd: function(map) {
      var el = L.DomUtil.create('a', 'hav-print leaflet-bar');
      el.title = this.options.title;
      el.setAttribute('href', '#');
      el.setAttribute('target', '_blank');
      el.setAttribute('role', 'button');

      L.DomUtil.create('i', 'fas fa-print fa-lg', el);
      L.DomEvent.on(el, 'click', this.options.onclick, el);

      return el;
    },
  });

  // @ts-ignore
  L.control.print = function(opts) {
    // @ts-ignore
    return new L.Control.Print(opts);
  };
});

